/**
 * Deals Service
 * @author TruNV
 */
import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {BaseService} from "../base.service";

@Injectable()
export class DealsService extends BaseService {

  private resourceUrl = this.apiUrl + 'dispensary';

  constructor(private http: HttpClient) {
    super();
  }

  getDispensary(disp_id) {
    return this.http.get(this.resourceUrl + `/${disp_id}`);
  }

  getGetDeals(disp_id, deal_cat_id, page) {
    const params: any = { deal_cat_id, page };
    const httpOptions = { headers: this.httpOptions.headers, params: params };
    return this.http.get(this.resourceUrl + `/${disp_id}/deals`, httpOptions);
  }
}
